import EmptyIcon from 'assets/images/noImage/background store 4.svg';
import useProductCountDown from 'utilities/hooks/countDownProduct/useProductCountDown';
import {useNavigate} from 'react-router-dom';
import classNames from 'classnames';
import {useState} from 'react';
const SaleCard = ({
  main_image,
  title,
  guid,
  price,
  negotiated_price,
  expire_date,
  app,
  type,
  post,
  createdDate,
  handleBokmarks,
}: ISaleMainCardProps) => {
  const [bookmarkSelected, setBookmarkSelected] = useState<boolean>(false);
  const navigate = useNavigate();
  const {days, hours} = useProductCountDown(expire_date);
  return (
    <>
      <div className=" shadow-md rounded-md p-2 flex my-4 h-32 " key={guid}>
        <div className=" ml-2 grow-1 relative">
          <span
            className={classNames(
              ' text-primary absolute bg-white p-2 bottom-1 rounded-full text-xl right-1',
              bookmarkSelected ? 'icon-bookmark-ads' : 'icon-bookmark-active',
            )}
            onClick={() => {
              setBookmarkSelected(!bookmarkSelected);
              handleBokmarks(post);
            }}
          ></span>
          <span className=" absolute top-1 right-1 rounded-full py-1 px-2 text-primary bg-white text-sm">
            {createdDate}
          </span>
          {main_image && main_image.image ? (
            <img
              src={main_image.image}
              alt="main"
              className=" h-full object-cover w-32 rounded-md"
            />
          ) : (
            <img
              src={EmptyIcon}
              alt="main "
              className=" h-full object-cover w-32 rounded-md"
            />
          )}
        </div>
        <div className=" grow-2">
          <div className=" flex flex-col justify-between h-full">
            <p
              className="grow font-extrabold text-gray-6"
              onClick={() =>
                navigate(`/${app}/${type}/${guid}`, {state: {guid}})
              }
            >
              {title}
            </p>
            <div>
              <div className="flex my-3">
                <span className="icon-offsell-card text-primary ml-1 mt-1"></span>
                {negotiated_price ? (
                  <p className=" text-gray-6">توافقی</p>
                ) : (
                  <p className=" text-gray-6">
                    {Number(price).toLocaleString()} تومان
                  </p>
                )}
              </div>
              <div className="flex mt-3">
                <span className="icon-clock text-error-3 ml-1"></span>
                <p className=" text-error-3 text-sm">
                  {days} روز و {hours} ساعت مانده
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SaleCard;
